import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from 'app/shared/util/toast.util';
import { CaseFileInspectionInputModel } from 'app/edozvola/case-file-inspection/model/case-file-inspection.model';
import {
  getFileInspectionCaptchaEnabled,
  getFileInspectionData
} from 'app/edozvola/case-file-inspection/service/case-file-inspection.service';
import { toast } from 'react-toastify';
import { setCase } from 'app/shared/reducers/case-entity';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import error = toast.error;

export const getFileInspectionDataMutation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (fileInspectionInputData: CaseFileInspectionInputModel) => {
      return getFileInspectionData(fileInspectionInputData);
    },
    onSuccess: (data, variables, context) => {
      dispatch(setCase(data));
      navigate(`/case-file-inspection/cases-preview/${data.idCase}`, { state: { from: 'case-file-inspection' } });
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const getFileInspectionCaptchaEnabledQuery = () => {
  return useQuery({
    queryKey: ['case-file-inspection', 'recaptcha'],
    queryFn: getFileInspectionCaptchaEnabled
  });
}
